import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'translateCut' })
export class TranslateCut implements PipeTransform {
  transform(value: string, index: number): string {
    return value && value.split('|')[index];
  }
}
